import { createSelector } from 'reselect';
import sectionTimeScale from "../modules/section-time-scale";
import * as d3Scale from "d3-scale";

// Actions
const SET_DURATION = "superloci/time/SET_DURATION";
const SET_POSITION = "superloci/time/SET_POSITION";
const SET_PLAYING = "superloci/time/SET_PLAYING";
const SET_DRAGGING = "superloci/time/SET_DRAGGING";

const initialState = {
    duration: null,
    position: 0,
    playing: false,
    dragging: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_DURATION: {
            return {
                ...state,
                duration: action.payload.duration,
            };
        }
        case SET_POSITION: {
            return {
                ...state,
                position: action.payload.position,
            };
        }
        case SET_PLAYING: {
            return {
                ...state,
                playing: action.payload.playing,
                // Reset if we're at the end and stopping
                position:   !action.payload.playing 
                            && state.position >= (state.duration - 1)
                                ? 0
                                : state.position
            };
        }
        case SET_DRAGGING: {
            return {
                ...state,
                dragging: action.payload.dragging,
            }
        }
        default:
            return state;
    }
}

// Action Creators
export function setDuration(duration) {
    return {
        type: SET_DURATION,
        payload: {
            duration,
        }
    }
}

export function setPosition(position) {
    return {
        type: SET_POSITION,
        payload: {
            position,
        }
    }
}

export function setPlaying(playing) {
    return {
        type: SET_PLAYING,
        payload: {
            playing,
        }
    }
}
export function setDragging(dragging) {
    return {
        type: SET_DRAGGING,
        payload: {
            dragging,
        }
    }
}

// ----
// Selectors
export const selectDuration = (state) => state.time.duration;
export const selectPosition = (state) => state.time.position;
export const selectPlaying = (state) => state.time.playing;
export const selectDragging = (state) => state.time.dragging;
export const selectCurrentTimestamp = createSelector(
    selectPosition,
    selectDuration,
    (state, video) => video,
    (position, duration, video) => {
        if (!video) {
            return 0;
        }
        if (!duration) {
            return video.processed.extents.time[0];
        }
        const timeScale = sectionTimeScale(video, duration);
        return timeScale(position);
    }
)



// WEBPACK FOOTER //
// ./src/ducks/time.js